import { Box, Typography } from "@mui/material";
import { EmptyMessageWrapper, ConsentListStyle } from "../block.style";

const CBEmptyPreview = () => {
  return (
    <Box sx={ConsentListStyle}>
      <EmptyMessageWrapper>
        <Typography variant="h3" color="grey">
          No consent block found
        </Typography>
      </EmptyMessageWrapper>
    </Box>
  );
};

export default CBEmptyPreview;
